// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Box, Typography } from '@mui/material';
// import TableComponent from '../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../Components/snackBar/snackBar';
// import { LoadingSpinner } from '../../Components/spinner/spinner';
// import { API_BASE_URL } from '../../config';

// export const DailySupremeCourtCasesComponent = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 20 },
//     { id: 'case_no', field: 'case_no', headerName: 'Case No.', width: 100 },
//     { id: 'name_of_the_parties', field: 'name_of_the_parties', headerName: 'Name of the Parties', width: 180 },
//     { id: 'date_of_filling', field: 'date_of_filling', headerName: 'Date of Filling', width: 130 },
//     { id: 'status', field: 'status', headerName: 'Status', width: 100 },
//     { id: 'previous_date_of_hearing', field: 'previous_date_of_hearing', headerName: 'Previous Date of Hearing', width: 160 },
//     { id: 'next_date_of_hearing', field: 'next_date_of_hearing', headerName: 'Next Date of Hearing', width: 160 },
//     {
//       id: 'links',
//       field: 'links',
//       headerName: 'Links',
//       width: 120,
//       renderCell: (params) => (
//         <a href={params.value} target="_blank" rel="noopener noreferrer">
//           Download
//         </a>
//       ),
//     },
//   ];

//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/home-notification/daily-supreme-court-cases/`)
//       .then((response) => {
//         const apiData = response.data.map((item, index) => ({
//           id: item.id || index,
//           slNo: index + 1,
//           case_no: item.case_no,
//           name_of_the_parties: item.name_of_the_parties,
//           date_of_filling: new Date(item.date_of_filling).toLocaleDateString('en-GB').replace(/\//g, '-'),
//           status: item.status,
//           previous_date_of_hearing: new Date(item.previous_date_of_hearing).toLocaleDateString('en-GB').replace(/\//g, '-'),
//           next_date_of_hearing: new Date(item.next_date_of_hearing).toLocaleDateString('en-GB').replace(/\//g, '-'),
//           links: item.link,
//         }));
//         setRows(apiData);
//         setSnackbarMessage('Daily supreme Court Cases data loaded successfully.');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error('Failed to fetch daily supreme court cases:', error);
//         setSnackbarMessage('Failed to load Daily supreme Court Cases data.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   }, []);

//   const handleSnackbarClose = () => {
//     setSnackbarOpen(false);
//   };

//   if (loading) {
//     return <LoadingSpinner size={30} />;
//   }

//   return (
//     <Box
//       sx={{
//         width: '100%',
//         mt: 8,
//         mb: 1,
//         borderRadius: 2,
//         boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//         backgroundColor: '#fff',
//       }}
//     >
//       <Box display="flex" justifyContent="center" backgroundColor="rgba(195, 234, 203, 0.1)" mb={2}>
//         <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
//           Supreme Court Cases
//         </Typography>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus={true}
//         enableSort={true}
//         sx={{
//           '& .MuiDataGrid-columnHeaders': {
//             backgroundColor: '#1976d2',
//             color: '#fff',
//             fontWeight: 'bold',
//           },
//         }}
//       />

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />
//     </Box>
//   );
// };


import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography } from '@mui/material';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { LoadingSpinner } from '../../Components/spinner/spinner';
import { API_BASE_URL } from '../../config';
import { useTranslation } from 'react-i18next';

export const DailySupremeCourtCasesComponent = () => {
  const { t } = useTranslation();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: t('supremeCourt.slNo'), width: 20 },
    { id: 'case_no', field: 'case_no', headerName: t('supremeCourt.caseNo'), width: 100 },
    { id: 'name_of_the_parties', field: 'name_of_the_parties', headerName: t('supremeCourt.nameOfParties'), width: 180 },
    { id: 'date_of_filling', field: 'date_of_filling', headerName: t('supremeCourt.dateOfFilling'), width: 130 },
    { id: 'previous_date_of_hearing', field: 'previous_date_of_hearing', headerName: t('supremeCourt.previousDate'), width: 160 },
    { id: 'next_date_of_hearing', field: 'next_date_of_hearing', headerName: t('supremeCourt.nextDate'), width: 160 },
    { id: 'status', field: 'status', headerName: t('supremeCourt.status'), width: 100 },
    // {
    //   id: 'links',
    //   field: 'links',
    //   headerName: t('supremeCourt.links'),
    //   width: 120,
    //   renderCell: (params) => (
    //     <a href={params.value} target="_blank" rel="noopener noreferrer">
    //       {t('supremeCourt.download')}
    //     </a>
    //   ),
    // },

    {
  id: 'links',
  field: 'links',
  headerName: t('advertisement.links'),
  width: 120,
  renderCell: (params) => {
    if (!params.value) {
      return <span>Not Found</span>;
    }
    return (
      <a href={params.value} target="_blank" rel="noopener noreferrer">
        {t('advertisement.download')}
      </a>
    );
  },
},

  ];

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/home-notification/daily-supreme-court-cases/`)
      .then((response) => {
        const apiData = response.data.map((item, index) => ({
          id: item.id || index,
          slNo: index + 1,
          case_no: item.case_no,
          name_of_the_parties: item.name_of_the_parties,
          date_of_filling: new Date(item.date_of_filling).toLocaleDateString('en-GB').replace(/\//g, '-'),
          status: item.status,
          previous_date_of_hearing: new Date(item.previous_date_of_hearing).toLocaleDateString('en-GB').replace(/\//g, '-'),
          next_date_of_hearing: new Date(item.next_date_of_hearing).toLocaleDateString('en-GB').replace(/\//g, '-'),
          // links: item.link,
        }));
        setRows(apiData);
        setSnackbarMessage(t('supremeCourt.successMessage'));
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Failed to fetch Daily Supreme Court cases:', error);
        setSnackbarMessage(t('supremeCourt.errorMessage'));
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  }, [t]);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  if (loading) {
    return <LoadingSpinner size={30} />;
  }

  return (
    <Box
      sx={{
        width: '100%',
        mt: 8,
        mb: 1,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
      }}
    >
      <Box display="flex" justifyContent="center" backgroundColor="rgba(195, 234, 203, 0.1)" mb={2}>
        <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
          {t('supremeCourt.heading')}
        </Typography>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus={true}
        enableSort={true}
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#1976d2',
            color: '#fff',
            fontWeight: 'bold',
          },
        }}
      />

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};
